app.factory('attachmentFileService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function AttachmentFile() {

        }

        return new AttachmentFile();
    }
]);
